<template>
  <div class="main-container">
    <div class="home-banner">
      <span>国产全栈流量管理专家</span>
    </div>
    <div class="architecture">
      <img style="width: 100%;height: 752px;" src="@/assets/imgs/home-arc.jpg" alt="首页架构图">
    </div>
    <div class="case">
      <h1 style="background-color: #fff;font-weight: bold;">应用场景</h1>
      <div class="case-links">
        <a v-for="item in caseButtons" :href="item.path">{{ item.meta.nameCN }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import menus from '@/router/menuRoutes.js'

export default {
  data() {
    return {
      homebannerUrl: require('@/assets/imgs/home-banner.jpg')
    }
  },
  computed: {
    caseButtons() {
      const casemenu = menus.find(item => item.path === '/case')
      return casemenu.children.filter((item, index) => index > 0)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.home-banner {
  color: #225fa4;
  // background-color: #ffffff;
  font-size: 50px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  vertical-align: middle;
}
.architecture{
  width: 100%;
  background-color: #fff;
}
.feature {
  width: 100%;
  height: 434px;
  display: flex;
  padding: 0 80px;
  .feature-left {
    width: 35%;
    text-align: left;
    margin-right: 120px;
    margin-top: 70px;
    .h1-title {
      padding: 10px 0;
      font-weight: 400;
      color: #171718;
      line-height: 35px;
    }
    p {
      text-indent: 2rem;
      line-height: 2rem;
    }
  }
  img {
    height: 210px;
    margin-top: 80px;
  }
}
.case {
  width: 100%;
  background-color: #fff;
  padding: 50px 0;
  .case-links{
    height: 300px;
    display: flex;
    flex-wrap: wrap;
    align-items: center; 
    justify-content: center; 
    align-content: space-evenly;
    column-gap: 50px;
    padding: 0 152px;
    a{
      padding: 15px 30px;
      border-radius: 4px;
      border: 2px solid #91d7f8;
      color: #171718;
      font-size: 22px;
    }
  }
}
</style>
